function Layout({ children }) {
  return (
    <div className="mobilityMutual__main">
      <div className="mobilityMutual__container">
        <div className="mobilityMutual__wrapper">{children}</div>
      </div>
    </div>
  );
}

export default Layout;
